import { ApplicationAIPassportData } from "@entities/commonTypes";
import { lazy, ComponentType } from "react";
//@FIXME: add types

interface AiPassportProps {
  userInfo: {
    name: string;
    photos: string;
  };
  userData?: ApplicationAIPassportData;
  buttonText?: string;
}

export const LazyAiPassport: ComponentType<AiPassportProps> = lazy(() =>
  import("../ui/AiPassport").then((module) => ({ default: module.AiPassport }))
);

export const LazyMatchAiLoading: ComponentType<any> = lazy(() =>
  import("../ui/MatchAiLoading").then((module) => ({
    default: module.MatchAiLoading,
  }))
);

export const LazyDatePicker: ComponentType<any> = lazy(() =>
  import("../ui/DatePicker").then((module) => ({ default: module.DatePicker }))
);

export const LazyTabs: ComponentType<any> = lazy(() =>
  import("../ui/Tabs").then((module) => ({ default: module.Tabs }))
);

export const LazySearchableItemList: ComponentType<any> = lazy(() =>
  import("../ui/SearchableItemList").then((module) => ({
    default: module.SearchableItemList,
  }))
);

export const LazySwiper: ComponentType<any> = lazy(() =>
  import("../ui/Swiper").then((module) => ({ default: module.Swiper }))
);

export const IntrodactionForm = lazy(() =>
  import("@features/introduction").then((module) => ({
    default: module.IntrodactionForm,
  }))
);
export const Community = lazy(() =>
  import("@pages/community").then((module) => ({ default: module.Community }))
);
export const CommunityById = lazy(() =>
  import("@pages/communityById").then((module) => ({
    default: module.CommunityById,
  }))
);
export const EmptyProfile = lazy(() =>
  import("@pages/emptyProfile").then((module) => ({
    default: module.EmptyProfile,
  }))
);
export const ErrorPage = lazy(() =>
  import("@pages/error").then((module) => ({ default: module.ErrorPage }))
);
export const Itroduction = lazy(() =>
  import("@pages/introduction").then((module) => ({
    default: module.Itroduction,
  }))
);
export const Match = lazy(() =>
  import("@pages/match").then((module) => ({ default: module.Match }))
);
export const Profile = lazy(() =>
  import("@pages/profile").then((module) => ({ default: module.Profile }))
);
export const Reactions = lazy(() =>
  import("@pages/reactions").then((module) => ({ default: module.Reactions }))
);
export const Streak = lazy(() =>
  import("@pages/streak").then((module) => ({ default: module.Streak }))
);
export const Tasks = lazy(() =>
  import("@pages/tasks").then((module) => ({ default: module.Tasks }))
);
export const UserPage = lazy(() =>
  import("@pages/user").then((module) => ({ default: module.UserPage }))
);
export const MatchSecondVersion = lazy(() =>
  import("@pages/matchSecondVersion").then((module) => ({
    default: module.MatchSecondVersion,
  }))
);
